import React, { useState } from 'react';
import { apiErrorText } from '../../utils/apiErrorText';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { HandCoins, MinusCircle, Undo2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Accounts settle a refund (negative reimbursement): repaid by the employee, or deducted from their next payout. */
export const RefundSettleActions = ({ expense, onDone }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  if (!(Number(expense?.amount) < 0) || !expense?.id) return null;
  const go = async (mode) => {
    setBusy(true);
    try { await axios.post(`${API}/expenses/${expense.id}/refund-settlement`, { mode }); toast.success(t(`refund.done.${mode}`)); onDone?.(); }
    catch (e) { toast.error(apiErrorText(e, t, 'refund.failed')); }
    finally { setBusy(false); }
  };
  if (expense.status === 'paid') return <Badge className="bg-emerald-100 text-emerald-800 text-[10px]" data-testid={`refund-settled-${expense.id}`}>{t('refund.settled')}</Badge>;
  if (expense.refund_settlement === 'deduct') {
    return (
      <div className="flex items-center gap-1">
        <Badge className="bg-sky-100 text-sky-800 text-[10px]" data-testid={`refund-deduct-badge-${expense.id}`}>{t('refund.willDeduct')}</Badge>
        <Button size="icon" variant="ghost" className="h-7 w-7" disabled={busy} title={t('refund.undo')} onClick={(e) => { e.stopPropagation(); go('none'); }} data-testid={`refund-undo-${expense.id}`}><Undo2 className="h-3.5 w-3.5" /></Button>
      </div>
    );
  }
  return (
    <div className="flex flex-wrap items-center gap-1">
      <Button size="sm" variant="outline" className="h-7 px-2 text-xs" disabled={busy} onClick={(e) => { e.stopPropagation(); go('repaid'); }} data-testid={`refund-repaid-${expense.id}`}><HandCoins className="h-3.5 w-3.5 mr-1" />{t('refund.repaid')}</Button>
      <Button size="sm" variant="outline" className="h-7 px-2 text-xs" disabled={busy} onClick={(e) => { e.stopPropagation(); go('deduct'); }} data-testid={`refund-deduct-${expense.id}`}><MinusCircle className="h-3.5 w-3.5 mr-1" />{t('refund.deduct')}</Button>
    </div>
  );
};

export default RefundSettleActions;
